// eslint-disable-next-line
export default {
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_PUBLIC_KEY,
    stripeApiKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY
}
